module.exports = __webpack_public_path__ + "a0399135543132e50f5da59646f778c4.svg";